"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SsrBuilderComponentIsolateSym = void 0;
exports.SsrBuilderComponentIsolateSym = Symbol('SsrBuilderComponentIsolateSym');
//# sourceMappingURL=ssrBuilderComponentIsolate.js.map